(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:CancellationTypesPublic
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('CancellationTypesPublic', CancellationTypesPublic);

  function CancellationTypesPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/cancellationTypes');
  }
}());
